/* @flow */
import * as React from 'react';
import { css } from 'linaria';

import { Container, Image } from './core';
import Colors from '../constants/Colors';
import withBreakpoint from './withBreakpoint';

const TinyStoreLogos = [
  {
    src: require('../../assets/images/logos/tiny/cpwm.png'),
    src2x: require('../../assets/images/logos/tiny/cpwm_2x.png'),
  },
  {
    src: require('../../assets/images/logos/tiny/west-elm.png'),
    src2x: require('../../assets/images/logos/tiny/west-elm_2x.png'),
  },
  {
    src: require('../../assets/images/logos/tiny/rh.png'),
    src2x: require('../../assets/images/logos/tiny/rh_2x.png'),
  },
  {
    src: require('../../assets/images/logos/tiny/pottery-barn.png'),
    src2x: require('../../assets/images/logos/tiny/pottery-barn_2x.png'),
  },
  {
    src: require('../../assets/images/logos/tiny/costco.png'),
    src2x: require('../../assets/images/logos/tiny/costco_2x.png'),
  },
  {
    src: require('../../assets/images/logos/tiny/cb.png'),
    src2x: require('../../assets/images/logos/tiny/cb_2x.png'),
  },
];

function TinyStoreLogoRow({ breakpoint }: { breakpoint: BreakpointSize }) {
  let logos = TinyStoreLogos;
  switch (breakpoint) {
    case 'small':
      // hide on small viewports
      return null;
    case 'medium':
      // remove Crate&Barrel logo on medium viewports
      logos = logos.slice(0, logos.length - 1);
      break;
  }
  return (
    <div className={Styles.TinyStoreLogoRow}>
      <Container size="large" className={Styles.TinyStoreLogoRowContainer}>
        {logos.map(({ src, src2x }) => (
          <Image src={src} src2x={src2x} className={Styles.TinyStoreLogo} key={src} />
        ))}
      </Container>
    </div>
  );
}
export default withBreakpoint(TinyStoreLogoRow);

const Styles = {
  TinyStoreLogoRow: css`
    background-color: ${Colors.opacity('#F8F8F9', 0.5)};
  `,
  TinyStoreLogoRowContainer: css`
    align-items: center;
    display: flex;
    flex-direction: row;
    height: 72px;
    justify-content: space-between;
    padding-left: 32px;
    padding-right: 32px;
  `,
  TinyStoreLogo: css`
    height: 20px;
  `,
};



// WEBPACK FOOTER //
// ./src/ui/components/TinyStoreLogoRow.js